<script setup lang="ts">
// Standalone page wrapper: the stops list is normally a tab of the home
// bottom sheet, but the stop-list URL is kept for existing deep links.
import StopsContent from './index.vue';
import { useAppStore } from '@/stores/app';

const appStore = useAppStore();
</script>

<template>
  <div class="page" :class="{ 'page--no-navbar': appStore.shouldHideNavbar }">
    <div class="content">
      <StopsContent />
    </div>
  </div>
</template>
